import { Snackbar, Link, IconButton, useTheme } from '@mui/joy';
import {
  faCircleExclamation,
  faXmark,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios, { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

export type ErrorMessagePopupProps = {
  isError: boolean;
  error?: unknown;
  retry?: () => void;
  onDismiss?: () => void;
};

const ErrorMessagePopup = ({
  isError,
  error,
  retry,
  onDismiss,
}: ErrorMessagePopupProps) => {
  const joyUiTheme = useTheme();
  const { t } = useTranslation();

  return (
    <Snackbar open={isError} color='danger' size='lg'>
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
        <FontAwesomeIcon icon={faCircleExclamation} />
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ fontWeight: 'bold' }}>{t('errors.general')}</div>
          <div style={{ fontSize: '14px' }}>
            {error instanceof AxiosError
              ? (error.response?.data?.error?.message ?? error?.message)
              : t('errors.unknown-error')}
          </div>
          <div style={{ fontSize: '14px' }}>
            {retry ? (
              <Link onClick={retry} color='danger' sx={{ fontSize: '14px' }}>
                {t('errors.try-again-click')}
              </Link>
            ) : (
              <>{t('errors.try-again')}</>
            )}
          </div>
          {axios.isAxiosError(error) && (
            <div style={{ fontSize: '12px', marginTop: '8px' }}>
              <div>
                {t('errors.correlation')}{' '}{error.config?.headers['correlation-id']}
              </div>
              <div>{t('errors.code')}{' '}{error.response?.data?.error?.code}</div>
            </div>
          )}
        </div>
        {onDismiss && (
          <div
            style={{
              display: 'flex',
              alignSelf: 'flex-start',
              height: '100%',
              flexGrow: 1,
            }}
          >
            <IconButton onClick={onDismiss}>
              <FontAwesomeIcon icon={faXmark} color={joyUiTheme.colorSchemes.light.palette.danger[500]} />
            </IconButton>
          </div>
        )}
      </div>
    </Snackbar>
  );
};

export default ErrorMessagePopup;
